module.exports = __webpack_public_path__ + "static/img/logo14.a61a340.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/logo14.png
// module id = SJ+l
// module chunks = 1